import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=b56c2868"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b56c2868')) {
      api.createRecord('b56c2868', component.options)
    } else {
      api.reload('b56c2868', component.options)
    }
    module.hot.accept("./CustomerList.vue?vue&type=template&id=b56c2868", function () {
      api.rerender('b56c2868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerList.vue"
export default component.exports